// Pure domain logic over notes: immutable state transitions and grouping.

import type { Note } from "./types.js";
import { dayKey } from "./format.js";

// State transitions: each returns a new Note, never mutating the input.
export const asPending = (note: Note): Note => ({
  ...note,
  status: "pending",
  errorMessage: null,
});

export const asSent = (note: Note): Note => ({
  ...note,
  status: "sent",
  errorMessage: null,
});

export const asError = (note: Note, message: string): Note => ({
  ...note,
  status: "error",
  errorMessage: message,
});

// Consecutive notes sharing the same day, grouped immutably.
export interface DayGroup {
  readonly day: string;
  readonly notes: readonly Note[];
}

export const groupByDay = (notes: readonly Note[]): readonly DayGroup[] =>
  notes.reduce<readonly DayGroup[]>((groups, note) => {
    const day = dayKey(note.timestamp);
    const last = groups[groups.length - 1];
    return last && last.day === day
      ? [...groups.slice(0, -1), { day, notes: [...last.notes, note] }]
      : [...groups, { day, notes: [note] }];
  }, []);
